import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const TableHead = ({ columnsNames, onClick, orderBy, sort }) => (
  <thead>
    <tr role="row">
      {columnsNames.map(({ key, value }) => (
        <th
          aria-label={value}
          className={classNames(`expand`, {
            sorting: !(orderBy === key) && key !== `options`,
            sorting_asc: orderBy === key && sort === `asc`,
            sorting_desc: orderBy === key && sort === `desc`,
            "hidden-xs": key === `options`
          })}
          colSpan={1}
          data-class="expand"
          key={key}
          rowSpan={1}
          style={{ width: `auto` }}
          tabIndex={0}
          onClick={key !== `options` ? onClick(key) : undefined}
        >
          {value}
        </th>
      ))}
    </tr>
  </thead>
);

TableHead.propTypes = {
  columnsNames: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  orderBy: PropTypes.string,
  sort: PropTypes.string
};

export default TableHead;
